import React from 'react';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';

import './Contact.scss';

import ContactScheduler from './ContactScheduler/ContactScheduler';
import ContactCall from './ContactCall/ContactCall';
import ContactDirectionForm from './ContactDirectionForm/ContactDirectionForm';

const API_KEY = 'AIzaSyBieaitf8vDRHaAc5rE67IAS9Y0--VpP-0';
const defaultProps = {
    zoom: 18
};

const WIDGET_MODES = {
    SCHEDULER: 0,
    CALL: 1
}

export default class Contact extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let dealerAddress = document.getElementById('appointment-wrap').getAttribute("data-address");

        let dealerOpeningHours = document.getElementById('appointment-wrap').getAttribute("opening-hours");
        let dealerOpeningHoursArr = dealerOpeningHours.split("\n");
        let listOpeningHours = dealerOpeningHoursArr.map((item) => <p className="sub-header">{item}</p>);

        let promotionRemark = document.getElementById('appointment-wrap').getAttribute("promotion-remark");

        var directionForm = <ContactDirectionForm dealerAddress={dealerAddress} />;
        var contactView = null;

        if (this.props.center.appointmentMode === WIDGET_MODES.SCHEDULER) {
            contactView = <ContactScheduler center={this.props.center} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")} />;
        } else if (this.props.center.appointmentMode === WIDGET_MODES.CALL) {
            contactView = <ContactCall center={this.props.center} campaignId={document.getElementById('appointment-wrap').getAttribute("campaignId")}/>;
        }

        return (
            <div className="appointment">
                <div className="appointment-widget">
                    {contactView}
                </div>
                <div className="row appointment-map">
                    <div className="col-sm-12 appointment-dealer-details">
                        <div className="col-sm-6 dealer-opening-hours">
                            <p><img className="marker" src="/images/contact/contact-work-hours.png" alt="hours"></img></p>
                            <h3>Opening hours</h3>
                            {listOpeningHours}
                            {promotionRemark && <p className="sub-description">* {promotionRemark}</p>}
                        </div>
                        <div className="col-sm-6 dealer-address">
                            <p><img className="marker" src="/images/contact/contact-address-point.png" alt="address"></img></p>
                            <h3>Our address</h3>
                            <p className="sub-header">{dealerAddress}</p>
                            {directionForm}
                        </div>
                    </div>
                    <div className="col-sm-12 appointment-google-map">
                        <GoogleMapReact
                            apiKey={API_KEY}
                            defaultCenter={this.props.center}
                            defaultZoom={defaultProps.zoom}>
                            <Marker
                                lat={this.props.center.lat}
                                lng={this.props.center.lng} />
                        </GoogleMapReact>
                    </div>
                </div>
            </div>
        );
    }
}

function Marker(props) {
    return (
        <div className="map-marker">
            <img className="marker" src="/images/components/location/location-pin.svg" alt="location-pin"></img>
        </div>
    );
}

let container = document.getElementById('appointment-wrap');
let center = {
    lat: +container.dataset.lat,
    lng: +container.dataset.lng,
    phoneNumber: container.dataset.phone,
    appointmentMode: +container.dataset.appointmentmode,
    appointmentDetails: container.dataset.appointmentdetails
};

ReactDOM.render(
    <Contact
        center={center}       
    />, container);


// WEBPACK FOOTER //
// ./Src/Contact/Contact.jsx